import React, { Component } from 'react'
import { Element } from 'react-scroll';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RequiredSpan from './RequiredSpan';
import Throbber from './Throbber';
import Validation from '../../../helper/validation';

class FormControl extends Component {
  render() {
    let className = ['form-item', 'usa-label'];

    if (this.props.hasError) {
      className.push('form-error');
    }

    return (
      <Element name={this.props.name} className={classNames(className, this.props.className)}>
        {this.props.label.length > 0 && <label className="usa-label control-label" htmlFor={this.props.name}>
          {this.props.label} <span className="usa-hint">{ this.props.hint }</span>
          <RequiredSpan hidden={!Validation.isRequired(this.props.name)} />
          {Validation.isRequired(this.props.name)}
          <Throbber showThrobber={this.props.showThrobber} />
        </label>}
        {this.props.children}
      </Element>
    )
  }
}

FormControl.defaultProps = {
  required: false,
  label: '',
  name: '',
  className: '',
  showThrobber: false,
  hasError: false,
};

FormControl.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  showThrobber: PropTypes.bool,
  hasError: PropTypes.bool,
};

export default FormControl;
